/** Exception types */
export const DRIVING_EXPERIENCE = 'driving_experience';
export const EMPLOYMENT_MULTIDOC = 'employment_proof_multidoc';
export const DRIVER_ABSTRACT = 'driver_abstract_documentation_requested';
export const MVR_DOCUMENTATION_REQUESTED = 'mvr_documentation_requested';
export const CONSENT_BASED_SSN_VERIFICATION = 'consent_based_ssn_verification';

/** Exception types whose document comments may contain clickable URLs. */
export const EXCEPTION_TYPES_WITH_LINKABLE_COMMENTS = [
  CONSENT_BASED_SSN_VERIFICATION,
];

/** Verification objects */
export const MATRIX_VERIFICATION = 'matrix_verification';
